import { Skeleton } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { IoInformationCircle } from 'react-icons/io5';
import { useParams } from 'react-router-dom';

import CButton from '../../components/button/button';
import CChip from '../../components/chip/chip';
import EditInstitution from '../../components/forms/edit_institution';
import CModal from '../../components/modal/modal';

import { Space } from '../../components/utils/utils';
import {
  getInstitution,
  getInstitutions,
  getOrderingRequests
} from '../../network/institution';
import { getLitigiiDetails } from '../../network/litigii';
import { RootState } from '../../redux';
import { useAppSelector } from '../../redux/hooks';
import {
  mapStatusToColor,
  typesRequestsMapping
} from '../../types/types-requests';
import { IInstitution, IOrderingSet } from '../../utils/interfaces/interfaces';
import { variables } from '../../utils/variables';
import styles from './litigii-detalii.module.scss';
import { parseString } from 'xml2js';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

interface ParamTypes {
  id: any;
}

const LitigiiDetails = () => {
  let { id } = useParams<ParamTypes>();

  const user = useAppSelector((state: RootState) => state.session.user);
  const subordonateInstitutions = useAppSelector(
    (state: RootState) => state.session.institutions
  );

  const [openedModal, setModal] = useState(false);
  const [institutions, setInstitutions] = useState([]);
  const [details, setDetails] = useState<any>();

  const [requests, setRequests] = useState({ data: [] });
  const [server_institution, setInitialInstitution] = useState(
    {} as IInstitution
  );
  const wrapperRef = useRef<HTMLDivElement>(null);

  const getRequests = () => {
    user &&
      getOrderingRequests(user.institutionId).then(({ data }) =>
        setRequests(data)
      );
  };

  const formatDate = (stringDate: string) => {
    let date = new Date(stringDate);
    let dd = date.getDate();
    let mm = date.getMonth() + 1;

    let yyyy = date.getFullYear();
    let ddd = '' + dd;
    if (dd < 10) {
      ddd = '0' + dd;
    }
    let mmm = '' + mm;
    if (mm < 10) {
      mmm = '0' + mm;
    }
    return ddd + '.' + mmm + '.' + yyyy;
  };

  const findInstitution = (institutionId: number): IInstitution | undefined =>
    institutions
      ? institutions.find(
          (institution: IInstitution) => institution.id === institutionId
        )
      : ({} as IInstitution);
  useEffect(() => {
    getRequests();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    getLitigiiDetails(id).then(({ data }) => {
      console.log(data);
      parseString(data.xml, function (err, result) {
        if (
          result['soap:Envelope']['soap:Body'][0].CautareDosareResponse[0]
            .CautareDosareResult === undefined
        ) {
          setDetails(null);
        } else {
          const fileResult =
            result['soap:Envelope']['soap:Body'][0].CautareDosareResponse[0]
              .CautareDosareResult[0]['Dosar'][0];
          setDetails(fileResult);
        }
      });
    });
    // eslint-disable-next-line
  }, [id]);

  return (
    <div className={styles.container}>
      <div className={styles.rowInfo}>
        <p className='subheading-dark bold'>Dosar {decodeURIComponent(id)}</p>
        <Space vertical='2vh' />
        <CButton
          type='submit'
          label='Descarca'
          onClick={async () => {
            const node = document.getElementById('litigation-details');
            const canvas = await html2canvas(node!);

            const imgData = canvas.toDataURL('image/png');

            const imgWidth = 210;
            const pageHeight = 295;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            let heightLeft = imgHeight;

            const doc = new jsPDF('p', 'mm');
            let position = 0;

            doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;

            while (heightLeft >= 0) {
              position = heightLeft - imgHeight;
              doc.addPage();
              doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
              heightLeft -= pageHeight;
            }
            doc.save(`dosar-${id}.pdf`);
          }}
        />
      </div>
      {details?.data.length > 0 && (
        <div id='litigation-details' style={{ padding: '30px' }}>
          <div className={styles.information}>
            <div className='wrap fullWidth justify-between'>
              <div className='column'>
                <Space vertical={variables.verticalSpace} />
                <Space vertical={variables.verticalSpace} />
                <p className='body-dark bold'>Numar dosar</p>
                <p className='body-dark'>{details?.numar[0] || '-'}</p>
              </div>
            </div>
          </div>
          <Space vertical='2vh' />

          <div className={styles.information}>
            <div className='wrap fullWidth justify-between'>
              <div className='column'>
                <p className='body-dark bold'>Data înregistrării</p>
                <p className='body-dark'>{formatDate(details?.data[0])}</p>
                <Space vertical={variables.verticalSpace} />
                <Space vertical={variables.verticalSpace} />
                <p className='body-dark bold'>Data ultimei modificari</p>
                <p className='body-dark'>
                  {formatDate(details?.dataModificare[0])}
                </p>
              </div>

              <div className='column'>
                <p className='body-dark bold'>Stadiu procesual</p>
                <p className='body-dark'>{details?.stadiuProcesualNume[0]}</p>
                <Space vertical={variables.verticalSpace} />
                <Space vertical={variables.verticalSpace} />
                <p className='body-dark bold'>Materie</p>
                <p className='body-dark'>
                  {details?.categorieCazNume[0] || '-'}
                </p>
              </div>
            </div>
          </div>
          <div className={styles.information}>
            <div className='wrap fullWidth justify-between'>
              <div className='column'>
                <Space vertical={variables.verticalSpace} />
                <Space vertical={variables.verticalSpace} />
                <p className='body-dark bold'>Obiect</p>
                <p className='body-dark'>{details?.obiect[0] || '-'}</p>
              </div>
            </div>
          </div>
          <Space vertical='2vh' />

          <div className={styles.information}>
            <Space vertical={variables.verticalSpace} />
            <Space vertical={variables.verticalSpace} />
            <p className='subheading-dark bold p-padding'>Parți</p>
            <div className='wrap fullWidth justify-between'>
              <div className='column'>
                <Space vertical={variables.verticalSpace} />
                <p className='body-dark bold'>Nume</p>
              </div>

              <div className='column'>
                <Space vertical={variables.verticalSpace} />
                <p className='body-dark bold'>Calitate parte</p>
              </div>
            </div>

            <div className='p-padding'>
              {details?.parti[0].DosarParte &&
                details?.parti[0].DosarParte.map(
                  (parte: any, index: number) => (
                    <div className='wrap fullWidth justify-between' key={index}>
                      <div className='column'>
                        <p className='body-dark'>{parte.nume[0]}</p>
                      </div>

                      <div className='column'>
                        <p className='body-dark'>{parte.calitateParte[0]}</p>
                      </div>
                    </div>
                  )
                )}
            </div>
          </div>
          <div className={styles.information}>
            <Space vertical={variables.verticalSpace} />
            <Space vertical={variables.verticalSpace} />
            <p className='subheading-dark bold p-padding'>Sedințe</p>

            <div className='p-padding'>
              {details?.sedinte &&
                details?.sedinte[0].DosarSedinta &&
                details?.sedinte[0].DosarSedinta.map(
                  (sedinta: any, index: number) => (
                    <div
                      className='wrap fullWidth justify-between'
                      key={formatDate(sedinta.data[0])}
                    >
                      <div className='column'>
                        <Space vertical={variables.verticalSpace} />
                        <p className='body-dark bold'>
                          {formatDate(sedinta.data[0])}
                        </p>
                        <p className='body-dark'>
                          Ora estimata: {sedinta.ora[0]}
                        </p>
                        <p className='body-dark'>
                          Complet: {sedinta.complet[0]}
                        </p>
                        <p className='body-dark'>
                          Tip solutie: {sedinta.solutie[0]}
                        </p>
                        <p className='body-dark'>
                          Solutia pe scurt: {sedinta.solutieSumar[0]}
                        </p>
                      </div>
                    </div>
                  )
                )}
            </div>
          </div>

          <Space vertical={variables.verticalSpace} />
          <Space vertical={variables.verticalSpace} />
          <Space vertical={variables.verticalSpace} />
        </div>
      )}
      {!(details?.data.length > 0) && (
        <div className={styles.information}>
          <div className='wrap fullWidth justify-between'>
            <div className='column'>
              <p className='body-dark bold'>Dosarul nu a fost gasit</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LitigiiDetails;
